import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiSelectDropdownComponent } from './multi-select-dropdown.component';
import {FormsModule} from '@angular/forms';
import { ProviderMultiSelectComponent } from './provider-multi-select/provider-multi-select.component';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import { PayorMultiSelectComponent } from './payor-multi-select/payor-multi-select.component';
import { SubdivisionMultiSelectComponent } from './subdivision-multi-select/subdivision-multi-select.component';
import { FacilityMultiSelectComponent } from './facility-multi-select/facility-multi-select.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  declarations: [
    MultiSelectDropdownComponent,
    ProviderMultiSelectComponent,
    PayorMultiSelectComponent,
    SubdivisionMultiSelectComponent,
    FacilityMultiSelectComponent
  ],
    exports: [
      MultiSelectDropdownComponent,
      ProviderMultiSelectComponent,
      PayorMultiSelectComponent,
      SubdivisionMultiSelectComponent,
      FacilityMultiSelectComponent
    ]
})
export class MultiSelectDropdownModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/multi-select-dropdown/multi-select-dropdown.module.ts